import service from '@/utils/request'
// 查询报价单
export function gysInquiryList(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/gysInquiryList',
		data: param
	})
}

